import moment from 'moment';
import weekDayNamesObject from '../i18n/week-day-names';

const getWeekDayName = (date, locale = 'pt-BR') => {
  const weekDayNames = weekDayNamesObject[locale];

  if (!weekDayNames) {
    throw new Error('There is no week day names for this locale');
  }

  const momentDate = moment(date);
  const weekday = momentDate.weekday();

  return weekDayNames[weekday];
};

export default getWeekDayName;



// WEBPACK FOOTER //
// ../utils/functions/get-week-day-name.js